import harmonyConfig from './harmonyConfig'
import { Base64 } from 'js-base64'
import { getQuerystringUrl } from '@/config/utils'
import { sendDingtalk } from '@/config/dingtalk'

const isDevelopment = process.env.NODE_ENV === 'development'
const isInApp = false

const COMMON = {
  '跳首页': {
    name: 'RETURN_HOMEPAGE'
  },
  '跳登录页': {
    name: 'APP_LOGIN'
  },
  '打开webview': {
    name: 'APP_NEW_OPEN_URL',
    versions: ['sd_ios_225', 'sd_and_123', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    paramsDemo: {
      'url': 'https://www.baidu.com', // 需要跳转的url
      'type': 'loan_market', // 贷超进入，需要返回弹出推荐框
      'title': '', // 界面标题
      'productId': '' // 产品id不为空且type=loan_market两者均满足情况下展示免责弹窗，否则不展示
    }
  },
  '打开原生': {
    name: 'OPEAN_NATIVE',
    versions: ['sd_ios_224', 'sd_and_122', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    paramsDemo: {
      'url': 'liveness?name=aaaa&idNumber=bbbbbb' // liveness人脸
      // 'url': 'ocr?type=redpacket', // ocr实名，type：redpacket红包兑换
      // 'url': 'choosebankcard' // choosebankcard选择银行卡
    }
  },
  '退出登录': {
    versions: ['sd_ios_224', 'sd_and_122', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    name: 'APP_LOGOUT'
  },
  '关闭webview': {
    versions: ['sd_ios_224', 'sd_and_122', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    name: 'CLOSE_WEBVIEW'
  },
  '返回拦截': {
    name: 'INTERCEPT_BACK',
    callback: 'nativeGoBack',
    versions: ['sd_ios_224', 'sd_and_122', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    paramsDemo: {
      'callback': 'xxx', // 执行
      'url': location.href,
      isRecord: 0, // 0否 ；1是需要埋点记录；2埋点并且返回，（iOS：226；Android：130）(字段要传)
      recordPara: { pageName: 'H5-xx', pageId: 'xx' } // （iOS：226；Android：130）
    }
  },
  '获取环境变量': {
    name: 'ENVIRONMENT_PARAMS',
    callback: 'nativeGetEnvironmentParam',
    demo: {
      'phone': '13200001111', // 注册手机号
      'appVersion': '200', // app版本
      'devOS': 'iOS' // 设备类型
    }
  },
  '获取通讯录': {
    name: 'ADDRESS_BOOK',
    callback: 'nativeAddressBook',
    demo: {
      'isPower': '0', // 0没授权，1已授权
      'addressList': '张三:13200001111,李四:13311110000' // 通讯录数据
    }
  },
  '获取紧急联系人': {
    name: 'EMERGENCY_CONTACT',
    callback: 'nativeGetEmergencyContact',
    demo: {
      'isPower': '0', // 0没授权，1已授权
      'EmergencyContact': { // 紧急联系人数据
        'name': '张三',
        'phone': '13200001111'
      },
      'addressList': '张三:13200001111,李四:13311110000' // 通讯录数据
    }
  },
  '打开分享弹窗': {
    name: 'APP_SHARE',
    // callback: 'nativeGetShareData',
    paramsDemo: {
      'shareUrl': '分享链接',
      'title': '标题',
      'content': '内容',
      'iconUrl': 'logo地址',
      'appLogin': '1 需要登录 0 不需要登录'
    },
    demo: {
      type: '1' // 是否分享成功：1成功，0失败
    }
  },
  '获取地理位置': {
    name: 'GPS_POSITION',
    versions: ['sd_ios_223', 'sd_and_119', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    callback: 'nativeGpsPosition',
    demo: {
      'isPower': '0', // 是否授权：1授权，0为授权
      'isSet': '0', // 0取消，1去设置
      // 'isSet': '0', // 0取消，1去设置
      'gpsMap': {
        'addressComponent': {
          'province': '浙江省',
          'city': '杭州市',
          'district': '萧山区'
        },
        'formattedAddress': '浙江省杭州市萧山区宁围街道金二路',
        'position': {
          'lng': 120.255849, // 经度
          'lat': 30.198129 // 纬度
        }
      }
    }
  },
  '地理位置授权': {
    name: 'GPS_POSITION_STATE',
    versions: ['sd_ios_223', 'sd_and_119', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0', 'kxd_and_0'],
    callback: 'nativeGpsPositionState',
    demo: {
      'isPower': '0', // 是否授权：1授权，0为授权
      'gpsMap': {
        'addressComponent': {
          'province': '浙江省',
          'city': '杭州市',
          'district': '萧山区'
        },
        'formattedAddress': '浙江省杭州市萧山区宁围街道金二路',
        'position': {
          'lng': 120.255849, // 经度
          'lat': 30.198129 // 纬度
        }
      }
    }
  },
  '保存图片': {
    name: 'SAVE_IMG',
    versions: ['sd_260', 'yjb_0', 'yjh_and_0', 'yhh_0', 'kxd_ios_0'],
    paramsDemo: {
      'imgUrl': 'https://www.baidu.com', // 图片文件地址
      'openUrl': 'https://www.baidu.com/，/home，weixin://，linziapp://easyloan' // 是否打开url：https相关url，app内部路 由，外部三方路由
    }
  },
  '签到提醒': {
    name: 'SIGNIN_REMIND',
    versions: ['sd_ios_224', 'sd_and_122', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0', 'kxd_ios_0'],
    callback: 'nativeSigninRemind',
    paramsDemo: {
      'type': '1' // 1签到提醒，2开启通知权限
    },
    demo: {
      'isPower': '1', // 是否授权：1授权，0为授权
      'type': '1' // 1签到提醒，2开启通知权限
    }
  },
  '获取剪切板内容': {
    name: 'GET_CLIPBOARD_INFO',
    versions: ['sd_ios_226', 'sd_and_130', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0'],
    callback: 'nativeClipboard',
    demo: {
      value: 'xxx' // value为String类型，多条信息使用“,”分割
    }
  },
  '打开二维码': {
    name: 'OPEN_SCAN_CODE',
    versions: ['sd_ios_227', 'sd_and_131', 'yjb_0', 'yjh_and_0', 'yhh_0', 'ds_ios_0', 'jkh_ios_0', 'byb_ios_0', 'thh_ios_0', 'yskh_ios_0'],
    callback: 'nativScanCodeResults',
    demo: {
      value: 'xxx'
    }
  },
  '去应用商店评价': {
    versions: ['sd_ios_281', 'sd_and_281', 'kxd_ios_0', 'kxd_and_0'],
    name: 'GO_EVALUATION'
  }
}

const AND = {
  '获取通话记录': {
    name: 'CALL_RECORD',
    versions: ['sd_and_119', 'yjh_and_0', 'yhh_and_0'],
    callback: 'nativeCallRecord',
    demo: {
      'isPower': '1',
      'CallLogList': '张三:13200001111,李四:13311110000'
    }
  },
  '获取appList': {
    name: 'APP_LIST',
    versions: ['sd_and_119', 'yjh_and_0', 'yhh_and_0'],
    callback: 'nativeAppList',
    demo: {
      'appList': '淘宝,钉钉'
    }
  },
  '上传appList': {
    name: 'LOCAL_DEAL_APP_LIST',
    versions: ['sd_and_123', 'yjh_and_0', 'yhh_and_0']
  },
  '获取电话识别码': {
    name: 'DEVICE_ID',
    versions: ['sd_and_119', 'yjh_and_0', 'yhh_and_0'],
    callback: 'nativeDeviceId',
    demo: {
      'isPower': '1', // 是否授权：1授权，0为授权
      'deviceId': 'xxxx'
    }
  },
  '获取环境参数': {
    name: 'GET_ENV_PARAMS',
    versions: ['sd_and_132', 'yjh_and_0', 'yhh_and_0'],
    callback: 'nativeEnvParams',
    demo: {
      envParams: 'xxx'
    }
  },
  '通知客户端': {
    name: 'POST_TRIGGER',
    versions: ['sd_and_281'],
    paramsDemo: {
      tiggerData: '1',
      nonce: 'xxx'
    }
  }
}

export function getNativeConfig (pkg, devOS, version, isHarmony) {
  const common = {}
  if (isHarmony) {
    Object.assign(common, harmonyConfig)
  } else {
    Object.assign(common, COMMON)
    if (devOS === 'and') {
      Object.assign(common, AND)
    }
  }
  const result = {}
  Object.keys(common).forEach(key => {
    const obj = common[key]
    let match = !obj.versions
    if (obj.versions) {
      const isMatch = obj.versions.find(v => {
        const match = v.match(/([a-z]+)_(and|ios)?_?(\d+)/)
        if (!match) {
          console.warn(`${key}的配置versions的格式有问题`)
          sendDingtalk(`${key}的配置versions的格式有问题`)
          return false
        }
        if (!match[1] || match[1] !== pkg) {
          return false
        }
        if (match[2]) {
          if (match[2] !== devOS) {
            return false
          }
        }
        if (+version < +match[3]) {
          return false
        }
        return true
      })
      match = !!isMatch
    }
    if (match) {
      result[key] = obj
    }
  })
  return result
}

export function notifyNative (Vue, config, urlParams, resolve, reject) {
  let url = `/lz-web/opennative?name=${config.name}`
  try {
    if (config.paramsDemo) {
      const demo = config.paramsDemo
      const pureKeys = Object.keys(demo).filter(key => !['', undefined, null].includes(demo[key]))
      if (pureKeys.length && !urlParams) {
        sendDingtalk(`urlParams参数未传，urlParams对象格式如下1：${JSON.stringify(demo)}`)
        throw new Error(JSON.stringify({ type: 'urlParams参数未传，urlParams对象格式如下：', data: demo }))
      }
      const emptyKey = pureKeys.find(key => urlParams[key] === undefined)
      if (emptyKey) {
        sendDingtalk(`urlParams对象缺少key: ${emptyKey}, urlParams格式如下2：${JSON.stringify(demo)}`)
        throw new Error(JSON.stringify({ type: `urlParams对象缺少key${emptyKey}, urlParams格式如下：`, data: demo }))
      }
      url = `${url}&params=${Vue.prototype.$base64.encodeURI(JSON.stringify(urlParams))}`
    }
    if (config.callback) {
      window[config.callback] = function (obj = 'e30=') {
        const data = JSON.parse(Vue.prototype.$base64.decode(decodeURIComponent(obj)))
        resolve(data)
      }
    }
    console.warn('----- my data is url: ', url, urlParams)
    if (sessionStorage.getItem('testH5')) { // PC浏览器上测试
      resolve(url)
    } else if ((isDevelopment && isInApp) || !isDevelopment) {
      window.location.href = url
    } else {
      resolve(url)
    }
  } catch (e) {
    const err = JSON.parse(e.message)
    console.error(err.type)
    err.data && console.log(err.data)
  }
}

export function noticeHarmony (type, config, urlParams, resolve, reject) {
  const msgOb = { msgType: config.name, data: '' }
  if (config.scene) {
    const url = 'linziapp://yhh' + config.scene
    if (type === '打开webview') {
      // 鸿蒙端 /webview 用 ohos.url 标准解析并自动解码一次。参数值里的 & 和 # 会被当成外层
      // deeplink 的分隔符，例如 qhsy?extParam=x&id=85 会丢掉 id、三方地址 #/?...&token= 会丢掉 token，
      // 所以只对含这两个字符的值编码一次；其余值保持原样拼接，确保原本能正常打开的页面不受影响。
      const query = Object.keys(urlParams).reduce((str, k) => {
        if (['', null, undefined].includes(urlParams[k])) return str
        const value = String(urlParams[k])
        str += `${k}=${/[&#]/.test(value) ? encodeURIComponent(value) : value}&`
        return str
      }, '').slice(0, -1)
      msgOb.data = url + (url.includes('?') ? '&' : '?') + query
    } else if (urlParams) {
      msgOb.data = getQuerystringUrl(url, { extraParams: urlParams })
    } else {
      msgOb.data = url
    }
  } else {
    if (type === '打开原生') {
      msgOb.data = 'linziapp://yhh' + (urlParams.url.startsWith('/') ? urlParams.url : `/${urlParams.url}`)
    } else if (urlParams) {
      msgOb.data = encodeURIComponent(Base64.encodeURI(JSON.stringify(urlParams)))
    }
  }
  if (config.callback) {
    window[config.callback] = function (obj) {
      resolve(obj)
    }
  }
  console.warn('----- my data is msgOb: ', msgOb)
  if ((isDevelopment && isInApp) || !isDevelopment) {
    window.harmonyBridge.postMessage(JSON.stringify(msgOb))
  } else {
    reject(true)
  }
}
